import { render, staticRenderFns } from "./UpcomingEvents.vue?vue&type=template&id=30b166f2&"
import script from "./UpcomingEvents.vue?vue&type=script&lang=ts&"
export * from "./UpcomingEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpcomingEvents.vue"
export default component.exports